import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import axios from "axios";
import DataTable from "react-data-table-component";
import { jdsTableStyles } from "../../components/jds/tableStyles";
import { JdsTableSkeleton } from "../../components/jds/JdsSkeleton";
import { JdsPagination } from "../../components/jds/JdsPagination";
import { JdsButton } from "../../components/jds/JdsButton";
import { JdsSearchInput } from "../../components/jds/JdsSearchInput";
import { JdsTag } from "../../components/jds/JdsTag";
import { PlusIcon } from "../../components/jds/icons";
import "../../components/jds/jds.css";

const subHeaderStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--space-8)",
  width: "100%",
};

const FilterComponent = ({ filterText, onClear, onFilter }) => (
  <JdsSearchInput
    id="plans-filter"
    placeholder="Buscar plano"
    filterText={filterText}
    onFilter={onFilter}
    onClear={onClear}
  />
);

export function Plans() {
  const columns = [

    {
      name: "Ações",
      selector: row => row.id,
      width: "110px",
      cell: row => (
        <Link to={`/plans/${row.gateway_id}`}>
          <JdsButton variant="outlined" color="neutral" size="sm">
            Editar
          </JdsButton>
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },
    {
      name: "Cadastrado em",
      selector: row => row.created_at,
      width: "150px",
      cell: row => (
        <div>{format(new Date(row.created_at), "dd/MM/yyyy HH:mm")}</div>
      ),
      sortable: true
    },
    {
      name: "Nome",
      selector: row => row.name,
      maxWidth: "350px",
      sortable: true
    },
    {
      name: "Status",
      selector: row => (row.active ? "Ativo" : "Inativo"),
      cell: row => (
        <JdsTag
          label={row.active ? "Ativo" : "Inativo"}
          color={row.active ? "success" : "neutral"}
        />
      ),
      width: "100px"
    },
    {
      name: "Dias de trial",
      selector: row => `${row.trial_days} dias`,
      width: "100px"
    },
    {
      name: "Duração",
      selector: row => `${row.periodicity} dias`,
      width: "100px"
    },
    {
      name: "Valor",
      selector: row => `R$${row.amount}`,
      width: "100px"
    },
    {
      name: "Grupo de planos",
      selector: row => row.feature_group_name,
      width: "300px",
      cell: row => (
        <div title={`${row.feature_group_name}`}>{row.feature_group_name}</div>
      )
    }
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );

  const fetchPlans = async page => {
    setLoading(true);
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/plans/?page=${page}&per_page=${perPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setTotalRows(response.data.data.totalItems);
    setLoading(false);
  };

  const handlePageChange = page => {
    fetchPlans(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/plans/?page=${page}&per_page=${newPerPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <div style={subHeaderStyle}>
        <FilterComponent
          onFilter={e => setFilterText(e.target.value)}
          onClear={handleClear}
          filterText={filterText}
        />
        <Link to="/plans/add">
          <JdsButton>
            Novo plano
            <PlusIcon />
          </JdsButton>
        </Link>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    fetchPlans(1);
  }, []);

  useEffect(() => {
    fetchPlans(1);
  }, [filterText]);

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg">Planos</h1>
      <p className="text-muted mb-10">Listagem de todos os planos</p>

      <div className="jds-card jds-card--flush">
        <div style={{ overflowX: "auto", width: "100%" }}>
          <DataTable
            columns={columns}
            data={data}
            customStyles={jdsTableStyles}
            progressPending={loading}
            progressComponent={<JdsTableSkeleton />}
            pagination
            perPage={perPage}
            paginationServer
            paginationTotalRows={totalRows}
            paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponent={JdsPagination}
            subHeader
            subHeaderAlign="left"
            subHeaderComponent={subHeaderComponentMemo}
            responsive={false}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
